import {
  TableCellText,
} from "@ceridianhcm/components";
import { FormatCurrency } from "../../../common/formatting";
import { CommonBlockFileName, CommonBlockPayDate, CommonBlockPeriodEndDate } from "../CommonColumnDefinition";

export const RoeFileColumnsDefinitions = () => {

  return [
    CommonBlockFileName(),
    CommonBlockPayDate(),
    CommonBlockPeriodEndDate(),
    {
      field: "roeCount",
      label: "ROE Count",
      cellTemplate: (cellContext: any) => (
        <TableCellText>
          <div title={cellContext.rowData.roeCount}>
            {cellContext.rowData.roeCount}
          </div>
        </TableCellText>
      ),
    },
    {
      field: "totalInsurableHours",
      label: "Total Insurable Hours",
      cellTemplate: (cellContext: any) => (
        <TableCellText>
          <div title={cellContext.rowData.totalInsurableHours}>
            {cellContext.rowData.totalInsurableHours}
          </div>
        </TableCellText>
      ),
    },{
      field: "totalInsurableAmount",
      label: "Total Insurable Amount",
      cellTemplate: (cellContext: any) => (
        <TableCellText>
          <div title={cellContext.rowData.totalInsurableAmount}>
            {FormatCurrency(cellContext.rowData.totalInsurableAmount)}
          </div>
        </TableCellText>
      ),
    },
  ];
};
